import { DataFormat as DataFormatDto, NumberRoundingMethod, TimestampPrecision as _TimestampPrecision } from 'src/app/services/api.services';

export type DataFormat = DataFormatDto;

export namespace DataFormat {
  export const defaultValue: DataFormat = {
    numberRounding: null,
    timestamp: _TimestampPrecision.Default,
    treatNullAsBlank: false
  };

  export const countOfDefault: DataFormat = {
    ...defaultValue,
  };

  export namespace TimestampPrecision {
    export const order: Record<_TimestampPrecision, number> = {
      "default": -1,
      "year": 0,
      "month": 1,
      "day": 2,
      "hours": 3,
      "minutes": 4,
      "seconds": 5,
      "milliseconds": 6,
    };

    export function lt(l: _TimestampPrecision, r: _TimestampPrecision) {
      return order[l] < order[r];
    }

    export function gt(l: _TimestampPrecision, r: _TimestampPrecision) {
      return order[l] > order[r];
    }

    export function lte(l: _TimestampPrecision, r: _TimestampPrecision) {
      return order[l] <= order[r];
    }

    export function gte(l: _TimestampPrecision, r: _TimestampPrecision) {
      return order[l] >= order[r];
    }
  }
}
